export default __webpack_public_path__ + "assets/svg/Other Icon.b5bd18178c6598d41fa699085358e4cc.svg";